
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';


@Component({
  selector: 'app-termine-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './termine-carousel.component.html',
  styleUrls: ['./termine-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermineCarouselComponent {
  public tiles: CarouselTile[] = [
    {
      img: {
        src: 'assets/img/heinstude9.jpg',
        // width: 5400,
        // height: 4050,
        alt: 'Hein-Stude kehrt von einem YSTM-Event zurück',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
        sizes: ['90vw'],
        priority: true,
        loading: 'eager',
      }
    },
    {
      img: {
        src: 'assets/img/ansegeln1.jpg',
        // width: 1120,
        // height: 840,
        alt: 'Ansegeln im YSTM',
        // srcset: [
        //   'assets/img/xs/ansegeln1.webp 688w',
        //   'assets/img/sm/ansegeln1.webp 912w',
        //   'assets/img/md/ansegeln1.webp 1120w',
        //   'assets/img/lg/ansegeln1.webp 1360w',
        //   'assets/img/xl/ansegeln1.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/pboot5.jpg',
        // width: 1120,
        // height: 742,
        alt: 'P-Boot im YSTM',
        // srcset: [
        //   'assets/img/xs/pboot5.webp 688w',
        //   'assets/img/sm/pboot5.webp 912w',
        //   'assets/img/md/pboot5.webp 1120w',
        //   'assets/img/lg/pboot5.webp 1360w',
        //   'assets/img/xl/pboot5.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/ansegeln2.jpg',
        // width: 1120,
        // height: 840,
        alt: 'Ansegeln im YSTM',
        // srcset: [
        //   'assets/img/xs/ansegeln2.webp 688w',
        //   'assets/img/sm/ansegeln2.webp 912w',
        //   'assets/img/md/ansegeln2.webp 1120w',
        //   'assets/img/lg/ansegeln2.webp 1360w',
        //   'assets/img/xl/ansegeln2.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/event1.jpg',
        // width: 3584,
        // height: 5400,
        alt: 'Event im YSTM',
        //breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
        sizes: ['90vw'],
        // loading: 'lazy',
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/party1.jpg',
        // width: 1120,
        // height: 629,
        alt: 'Fest im YSTM',
        // srcset: [
        //   'assets/img/xs/party1.webp 688w',
        //   'assets/img/sm/party1.webp 912w',
        //   'assets/img/md/party1.webp 1120w',
        //   'assets/img/lg/party1.webp 1360w',
        //   'assets/img/xl/party1.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/party2.jpg',
        // width: 1120,
        // height: 629,
        alt: 'Fest im YSTM',
        // srcset: [
        //   'assets/img/xs/party2.webp 688w',
        //   'assets/img/sm/party2.webp 912w',
        //   'assets/img/md/party2.webp 1120w',
        //   'assets/img/lg/party2.webp 1360w',
        //   'assets/img/xl/party2.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/heinstude8.jpg',
        // width: 5400,
        // height: 4050,
        alt: 'YSTM Auswanderer Hein-Stude',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
        //priority: true,
      }
    },
  ];
}
